module.exports = __webpack_public_path__ + "static/Deicide-fcfb982b49427b0fb218b8d7a2d0b842.png";